<template>
  <div class="main-data" v-loading="loading">
    <el-row>
      <el-col :xs="24" :sm="24" :md="22" :lg="20" :xl="16">
        <el-form
          ref="form"
          :model="form"
          :rules="rules"
          label-position="top"
          size="large"
        >
          <el-row :gutter="10">
            <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="8">
              <el-form-item label="Qator sarlavhasi" prop="order_title">
                <el-input
                  placeholder="Qator sarlavhasi"
                  controls-position="right"
                  class="form-input"
                  v-model="form.order_title"
                />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="8">
              <el-form-item label="Qator havolasi" prop="order_link">
                <el-input
                  placeholder="Qator havolasi"
                  controls-position="right"
                  class="form-input"
                  v-model="form.order_link"
                />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="8">
              <el-form-item label="Budjet yili" prop="budget_year">
                <el-input-number
                  placeholder="Budjet yili"
                  controls-position="right"
                  class="form-input"
                  v-model="form.budget_year"
                />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="8">
              <el-form-item label="Daromaad" prop="income">
                <el-input-number
                  placeholder="Daromad"
                  controls-position="right"
                  class="form-input"
                  v-model="form.income"
                />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="8">
              <el-form-item label="Xarajat" prop="outcome">
                <el-input-number
                  placeholder="Xarajat"
                  controls-position="right"
                  class="form-input"
                  v-model="form.outcome"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item>
                <el-button class="custom-btn" @click="() => this.$router.go(-1)"
                  >Orqaga</el-button
                >
                <el-button class="custom-btn" type="primary" @click="onSubmit"
                  >Saqlash</el-button
                >
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { ElNotification } from "element-plus";

export default {
  name: "BudgetParamsForm",
  data() {
    return {
      loading: false,
      editId: null,
      form: {
        order_title: null,
        order_link: null,
        budget_year: null,
        income: null,
        outcome: null,
      },
      rules: {
        budget_year: [
          { required: true, message: "Majburiy maydon", trigger: "blur" },
        ],
        income: [
          { required: true, message: "Majburiy maydon", trigger: "blur" },
        ],
        outcome: [
          { required: true, message: "Majburiy maydon", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    getBudgetParam() {
      this.loading = true;
      this.$http
        .get(`api/v1/budget-params/${this.editId}`)
        .then(({ data }) => {
          this.form = data;
        })
        .catch(({ response }) => {
          ElNotification.error({
            message:
              response.data.message ||
              "Ma'lmumot yuklasda xatolik sodir bo'ldi!",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;

          let http;

          const formData = { ...this.form };

          if (this.editId) {
            http = this.$http.put(
              `/api/v1/budget-params/${this.editId}`,
              formData
            );
          } else {
            http = this.$http.post("/api/v1/budget-params", formData);
          }

          http
            .then(() => {
              ElNotification({
                title: "Tabriklaymiz",
                message: "Muvafaqiyatli saqlandi",
                type: "success",
              });
              this.$router.go(-1);
            })
            .catch(({ response }) => {
              ElNotification({
                title: "Xatolik",
                message:
                  response.data.message || "Iltimos, qayta urinib ko'ring.",
                type: "error",
              });
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
  },
  mounted() {
    if (this.$route.params.id) {
      this.editId = this.$route.params.id;
      this.getBudgetParam();
    }
  },
};
</script>

<style scoped>
.form-input {
  width: 100%;
}
</style>
